import { yupResolver } from "@hookform/resolvers/yup";
import { getToday } from "api/constants";
import { GetDownloadCategories, PostDownloads, UploadFile } from "api/endpoints";
import MEICKEditor from "components/ckeditor/MEICKEditor";
import FilePreviewer from "components/ckeditor/MEIFilePreview";
import MEILoader from "components/ckeditor/MEILoader";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

import { Card, FloatingLabel, } from "react-bootstrap";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { FiUpload } from "react-icons/fi";
import { toast } from "react-toastify";
import * as yup from "yup";
// import ProductBasicInfo from "./add-product-tab/ProductBasicInfo";

const schema = yup
  .object({
    fTitle: yup.string().required("Person name is required."),
    fDescription: yup.string(),
    // fFile: yup.string().required("File is required."),
    fFile: yup.string(),
    fCateg: yup.number(),
    fStatus: yup.string().required("Status is required."),
    fDate: yup.string(),
    eLink: yup.string().required("Details required."),


    smFB: yup.string(),
    smTW: yup.string(),
    smIG: yup.string(),
    smGP: yup.string(),

    fOrder: yup.number().required("Sequence is required.").min(0, 'Please enter valid number'),
  })
  .required();

const initialForm = {
  fTitle: '',
  fDescription: '',
  fFile: '',
  fCateg: 0,
  fStatus: 'true',
  fDate: getToday(),
  eLink: '',
  fOrder: '0',

  smFB: '',
  smTW: '',
  smIG: '',
  smGP: '',

};

const ProductBasicInfo = ({ setLoading }) => {
  const {
    register,
    formState: { errors },
    getValues,
    setValue,
    watch
  } = useFormContext();


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {

      const allowedTypes = [
        'image/jpeg', // .jpg, .jpeg
        'image/png',  // .png
      ];
      if (!allowedTypes.includes(file.type)) {
        toast.error('Invalid File Format', {
          theme: "colored",
        });
        e.target.value = '';
        return
      }
      else {
        setLoading(true)
        const formData = new FormData();
        formData.append('file', file);

        UploadFile(formData).then(res => {
          // toast.success('File Uploaded Successfully!', {
          //   theme: "colored",
          // });
          setValue('fFile', res?.data)
          e.target.value = '';
          setLoading(false)

        }).catch(err => {
          setLoading(false)
          toast.error('File Uploading Failed', {
            theme: "colored",
          });
        });
      }

    }
  };

  return (
    <Row className="gx-2 gy-3">

      <Col md="12">
        <Form.Group>
          {/* <Form.Label>First name:</Form.Label> */}
          <FloatingLabel
            controlId="floatingInput"
            label="Person Name"
            className=""
          >
            <Form.Control
              type="text"
              placeholder=""
              isInvalid={!!errors.fTitle}
              {...register("fTitle")}
            />
            <Form.Control.Feedback type="invalid">
              {errors.fTitle?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>



      {/* <Col md="12">

        <Form.Label>Description</Form.Label>
        <MEICKEditor
          value={getValues('fDescription')}
          onchangeValue={(vl) => {
            setValue('fDescription', vl)
          }} />

      </Col> */}



      <Col md="12">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Joining / Serving Details (Time period)" className="">
            <Form.Control
              type="text"
              placeholder=""
              isInvalid={!!errors.eLink}
              {...register("eLink")}
            >

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.eLink?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>


      <Col md="6" style={{ position: 'relative' }}>
        {/* <Form.Group>
          <FloatingLabel
            controlId="floatingInput"
            label="Profile Image"
            className=""
          >
            <Form.Control
              type="text"
              placeholder=""
              isInvalid={!!errors.fFile}
              // style={{height: '80px'}}
              {...register("fFile")}
              onKeyDown={e => e.preventDefault()}
            />
            <Form.Control.Feedback type="invalid">
              {errors.fFile?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group> */}

        <Form.Label style={{ left: 10, position: 'absolute', top: 0 }}>
          Profile Image (250 x 250)
        </Form.Label>
        <FilePreviewer accept=" .jpg, .jpeg, .png" furl={watch('fFile')} />


        <Form.Label htmlFor={`file-upload-ls`} style={{ position: 'absolute', zIndex: 99, right: 20, top: '20%', cursor: 'pointer', textDecoration: 'underline' }} className="text-info">
          <FiUpload className="me-1" size={40} />
        </Form.Label>

        <Form.Control
          id={`file-upload-ls`}
          type="file"
          style={{ width: '120px' }}
          onChange={(e) => handleFileChange(e)}
          className="d-none"
          accept=" .jpg, .jpeg, .png"
        />

      </Col>




      <Col md="6">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Status" className="">
            <Form.Control
              as="select"
              placeholder=""
              isInvalid={!!errors.fStatus}
              {...register("fStatus")}
            >
              <option value="true">Published</option>
              <option value="false">Un-Published</option>

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.fStatus?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>




      <Col md="6">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Facebook" className="">
            <Form.Control
              type="url"
              placeholder=""
              isInvalid={!!errors.smFB}
              {...register("smFB")}
            >

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.smFB?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>

      <Col md="6">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Twitter" className="">
            <Form.Control
              type="url"
              placeholder=""
              isInvalid={!!errors.smTW}
              {...register("smTW")}
            >

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.smTW?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>

      <Col md="6">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Instagram" className="">
            <Form.Control
              type="url"
              placeholder=""
              isInvalid={!!errors.smIG}
              {...register("smIG")}
            >

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.smIG?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>

      <Col md="6">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Google Plus" className="">
            <Form.Control
              type="url"
              placeholder=""
              isInvalid={!!errors.smGP}
              {...register("smGP")}
            >

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.smGP?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>




      <Col md="6">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Sequence Order" className="">
            <Form.Control
              type="number"
              placeholder=""
              isInvalid={!!errors.fOrder}
              {...register("fOrder")}
            >

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.fOrder?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>

    </Row>
  );
};


const AddLeadership = ({ handleDiscard, editData }) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const { handleSubmit, reset } = methods;

  // const [categories, setCategories] = useState([]);
  // const fetchCategories = () => {
  //   GetDownloadCategories().then(res => {
  //     setCategories(res?.data?.data?.map(cat => ({id: cat.id, name: cat.name})))
  //   }).catch();
  // }
  // useEffect(() => {
  //   fetchCategories();
  // }, [])

  useEffect(() => {
    if (editData?.id) {

      const esdesc = JSON.parse(editData.description);
      reset({
        fTitle: editData.title,
        fDescription: '',
        fFile: editData.fileName,
        fCateg: editData.categoryId,
        fStatus: editData.status.toString(),
        fDate: editData.fileDate.slice(0, 10),
        fOrder: editData.order,
        eLink: esdesc.description,
        smFB: esdesc.smFB,
        smIG: esdesc.smIG,
        smTW: esdesc.smTW,
        smGP: esdesc.smGP,
      })
    }
    else {
      reset(initialForm);
    }

  }, [editData])

  const [loading, setLoading] = useState(false);

  const onSubmit = (data) => {
    console.log(data);
    // // ------- Get all object keys form data and set empty values to reset ------------
    // const keys = Object.keys(data);
    // for (const key of keys) {
    //   submittedValues[key] = "";
    // }

    setLoading(true)
    const edesc = JSON.stringify({
      description: data.eLink,
      smFB: data.smFB,
      smIG: data.smIG,
      smTW: data.smTW,
      smGP: data.smGP,
    });
    const finalData = {
      id: editData?.id ? editData?.id : 0,
      title: data.fTitle,
      description: edesc,
      fileName: data.fFile,
      fileDate: data.fDate,
      categoryId: 0,
      status: data.fStatus === "true",
      order: data.fOrder,
      types: 'LEADERSHIP'
    }

    PostDownloads(finalData).then(res => {

      toast.success('Data Saved Successfully', {
        theme: "colored",
      });
      setLoading(false)
      reset(initialForm)
      handleDiscard(true);

    }).catch(err => {

      toast.error('Data Saving Failed', {
        theme: "colored",
      });
      setLoading(false)
      console.log(err, 'PostDownloadsError')

    });


  };

  const handleDiscardPre = () => {
    reset(initialForm)
    handleDiscard();
  }

  return (
    <>

      <MEILoader showLoader={loading} />
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="g-3">

            <Col lg={12}>
              <ProductBasicInfo setLoading={setLoading} />
            </Col>

            <Col xs={12}>
              <Row className="flex-between-center mt-3">
                <Col md>
                  {/* <h5 className="mb-2 mb-md-0">You're almost done</h5> */}
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={handleDiscardPre}
                  >
                    Discard
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    {editData?.id ? 'Update' : 'Add'}
                  </Button>
                </Col>
              </Row>
            </Col>

          </Row>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddLeadership;
